import {Http} from './index.js'
import {encodeQueryParams, buildUrlFilterParams} from '@/utils/api.js'
import Resource from './resource-class'

class TaxonomyAPI extends Resource {
  constructor () {
    super()
    this.resource = '/taxonomy'
  }

  getTaxFull ({params = {limit: 100}, filterParams = {}} = {}) {
    const queryParams = [encodeQueryParams(params), buildUrlFilterParams(filterParams)].join('&')
    return Http.get(`${this.resource}/query?${queryParams}`)
  }

  getLineage (taxonomyId) {
    const url = `${this.resource}/id/${taxonomyId}/descendants`
    return Http.get(url)
  }

  create ({name, rank, parentTaxonomyId}) {
    const payload = {
      name,
      rank,
      parent_taxonomy_id: parentTaxonomyId
    }
    return Http.post(this.resource, payload)
  }
}

export default new TaxonomyAPI()
